import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  withStyles,
} from "@material-ui/core";
import CheckBox from "../checkBox/CheckBox";
import React, { Component } from "react";
import styles from "./CheckBoxDialog.module.scss";
import Clear from "@material-ui/icons/Clear";

const StyledClear = withStyles({
  root: {
    width: 35,
    height: 35,
    fill: "#102b4e",
    align: "right",
  },
})(Clear);

class CheckBoxDialog extends Component {
  constructor() {
    super();
    this.state = {
      checked: false,
    };
    this.toggleCheck = this.toggleCheck.bind(this);
  }

  toggleCheck() {
    this.setState((prevState) => ({
      checked: !prevState.checked,
    }));
  }

  render() {
    return (
      <Dialog
        className={styles.dialogWrapper}
        open={this.props.open}
        onClose={this.props.onClose}
        aria-labelledby="check-b"
      >
        <div className={styles.cancel}>
          <button data-testid="closeDialogId" onClick={this.props.onClose}>
            <StyledClear />
          </button>
        </div>
        <DialogTitle className={styles.dialogTitle} id="form-dialog-title">
          {this.props.title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText className={styles.dialogDescription}>
            {this.props.text}
          </DialogContentText>
          <div className={styles.checkbox}>
            <CheckBox
              id="dialog-checkbox"
              checked={this.state.checked}
              isDisabled={false}
              name="checkBoxDialog"
              label={this.props.checkboxLabel}
              onChange={this.toggleCheck}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onClose} className={styles.applyCancel}>
            {this.props.cancelText || "CANCEL"}
          </Button>
          <Button
            onClick={this.props.onConfirm}
            disabled={!this.state.checked}
            className={styles.applySave}
          >
            {this.props.confirmText || "CONFIRM"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default CheckBoxDialog;
